import { OnInit } from "@angular/core";
import { Component } from "@angular/core";
import { CommonService } from "src/app/utility/services/common.service";

@Component({
  selector: "edtell-api-documentation",
  templateUrl: "./api-documentation.component.html",
  styleUrls: ["./api-documentation.component.scss"],
})
export class ApiDocumentationComponent implements OnInit {
  constructor(private commonService: CommonService) {}

  async ngOnInit() {}
}
